import axios from "axios";
import {CONFIG} from "@/common/config";

export const api = {
    //auth
    issueToken: (username, password, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/login',
            method: 'POST',
            data: {
                username: username,
                password: password
            }
        })
            .catch(() => {
            })
            .then(callback)
    },
    createUser: (username, password, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/users',
            method: 'POST',
            data: {
                username: username,
                password: password
            },
        })
            .catch(() => {
            })
            .then((response) => {
                if (response?.data?.status === 'error') {
                    callback(response.data?.message)
                    return
                }

                callback(null)
            })
    },
    getUser(token, id, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/users/' + id,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        })
            .then(callback)
    },
    updateRegisterSubmission: (id, hash, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/users/' + id + '/registration-submission',
            method: 'PUT',
            data: {
                hash: hash
            }
        })
            .catch(() => {
            })
            .then((response) => {
                if (response?.data?.status === 'error') {
                    callback(response.data?.message)
                    return
                }

                callback(null)
            })
    },
    createForgotLink(email, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/forgot-links',
            method: 'POST',
            data: {
                email: email
            }
        })
            .catch(() => {
            })
            .then((response) => {
                if (response?.data?.status === 'error') {
                    callback(response.data?.message)
                    return
                }

                callback(null)
            })
    },
    updateForgotLink: (id, password, token, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/forgot-links/' + id,
            method: 'PATCH',
            data: {
                token: token,
                password: password
            }
        })
            .catch(() => {
            })
            .then((response) => {
                if (response?.data?.status === 'error') {
                    callback(response.data?.message)
                    return
                }

                callback(null)
            })
    },

    //cars
    getCars: (token, params, signal, callback) => {
        const headers = {}
        if (token !== null) {
            headers['Authorization'] = 'Bearer ' + token
        }

        axios({
            url: CONFIG.API_HOST + '/api/v1/cars',
            params: params,
            headers: headers,
            signal: signal
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    getCarById: (token, id, callback) => {
        let headers = {}
        if (token !== null) {
            headers.Authorization = 'Bearer ' + token
        }
        axios({
            url: CONFIG.API_HOST + '/api/v1/cars/' + id,
            headers: headers
        })
            .then(callback)
    },

    //filters
    getFilters: (token, type, data, signal, callback) => {
        const headers = {}
        if (token !== null) {
            headers['Authorization'] = 'Bearer ' + token
        }

        axios({
            url: CONFIG.API_HOST + '/api/v1/filters/' + type,
            headers: headers,
            params: data,
            signal: signal
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },

    //profile
    async getProfile(token) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/profiles/current',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .catch(() => {
                return null
            })
    },
    async createProfile(token, data) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/profiles',
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        })
    },
    async updateProfile(token, data) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/profiles/current',
            method: 'PATCH',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        })
    },
    async updatePassword(token, data) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/users/current/password',
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        })
    },
    sendCarRequest: async (token, data) => {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/requests',
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        })
    },
    getCurrentCarRequests: (token, params, signal, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/requests/current',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    getCarRequests: (token, params, signal, callback) => {
        axios({
            url: CONFIG.API_HOST + '/api/v1/requests',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    getCarRequestById(token, id, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/requests/' + id,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
    },
    async cancelCarRequestById(token, id) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/requests/' + id + '/cancel',
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
    },
    async createCarRequestStatus(token, id, data) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/requests/' + id + '/statuses',
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data
        })
    },
    uploadFiles(token, carRequestId, data, callback) {
        const formData = new FormData()
        for (const file of data.files) {
            formData.append('files[]', file)
        }
        axios({
            url: CONFIG.API_HOST + '/api/v1/requests/' + carRequestId + '/attachments',
            method: 'POST',
            data: formData,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
    },
    loadFiles(token, carRequestId, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/requests/' + carRequestId + '/attachments',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
    },
    getPayments(token, params, signal, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/payments',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    createPayments(token, data, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/payments',
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data: data
        })
            .then(callback)
    },
    getAccountStatistics(token, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/statistics/accounts/current',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
    },
    getAccountStatisticsById(token, id, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/statistics/accounts/' + id,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
    },
    getClientsAccountant(token, params, signal, callback) {
        axios({
            url: CONFIG.API_HOST + '/api/v1/users',
            params: params,
            signal: signal,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then(callback)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async downloadFile(token, id) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/files/' + id + '/content',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            responseType: 'blob'
        })
    },
    async getInvoices(token, params, signal) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/invoices',
            params: params,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async getInvoice(token, id, signal){
        return axios({
            url: CONFIG.API_HOST + '/api/v1/invoices/' + id,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async createInvoice(token, params, signal) {
       return axios({
            url: CONFIG.API_HOST + '/api/v1/invoices',
            method: 'POST',
            data: params,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            signal: signal
        })
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async getChatToken(token) {
        let request = {
            url: CONFIG.API_HOST + '/api/v1/chat-tokens/current',
            method: 'GET'
        }
        if (token !== null) {
            request.headers = {
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios(request)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async createChatToken(token) {
        let request = {
            url: CONFIG.API_HOST + '/api/v1/chat-tokens',
            method: 'POST'
        }
        if (token !== null) {
            request.headers = {
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios(request)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async deleteChatToken(token) {
        let request = {
            url: CONFIG.API_HOST + '/api/v1/chat-tokens/current',
            method: 'DELETE'
        }
        if (token !== null) {
            request.headers = {
                'Authorization': 'Bearer ' + token
            }
        }
        return await axios(request)
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
    async sendExternalRequest(params) {
        return axios({
            url: CONFIG.API_HOST + '/api/v1/requests/external',
            method: 'POST',
            data: params
        })
            .catch((e) => {
                if (axios.isCancel(e)) {
                    return
                }
                throw e
            })
    },
}